import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { OrderSellers } from 'modules/orders/types'

const loadOrderBusinessUnities = (
  params: PaginatedParams
): PaginatedResponse<OrderSellers> => {
  const { page = 1, limit = 10 } = params

  return axios.get('/orders/business-unity', {
    params: {
      page,
      limit,
      ...params
    }
  })
}

export function useLoadOrderBusinessUnities(params: PaginatedParams) {
  return useQuery(
    ['orderBusinessUnities', params],
    () => loadOrderBusinessUnities(params),
    {
      keepPreviousData: true,
      onError: () =>
        toast.error('Não foi possível carregar unidades de negócio', {
          toastId: 'loadOrderBusinessUnities'
        })
    }
  )
}
